module.exports = __webpack_public_path__ + "img/mehmet-kirci-tick.07f0a35d.png";